/** `dataset.amplifiSessionUserId` writes `data-amplifi-session-user-id`. */
export const AMPLIFI_SESSION_USER_DATASET_KEY = 'amplifiSessionUserId';

export const AMPLIFI_SESSION_USER_ATTRIBUTE = 'data-amplifi-session-user-id';
